/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

export default function getItem(_, id, name) {
  /**
   * id field contains iamId
   *
   * This is because `/identity/users` returns iamId in the id field
   * We kept the same structure also for `/internal-api/users` to keep the implementation simple
   *
   * `/identity/users` endpoint is used for Keycloak authentication
   * `/internal-api/users` endpoint is used for custom OIDC providers
   */
  return id && name ? { id, name } : null;
}
